const getLink = (link, micrositePermalink) => {
    if (link.includes('://') || !micrositePermalink) {
        return link;
    }
    return `${micrositePermalink}${link}`;
};

export default getLink;
